import { useEffect, useRef, useState } from "react";
import Layout from "../components/layout/Layout.component";
import ContatoDetails from "../styles/pages/ContatoDetails";

import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid2,
  Typography,
  useTheme,
} from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { BsWhatsapp } from "react-icons/bs";
import vector from "../assets/contact.png";
import Input from "../components/inputs/Input.component";
import MessageIcon from "@mui/icons-material/Message";
import emailjs from "@emailjs/browser";

interface InputsForm {
  user_name: string;
  user_email: string;
  telefone: string;
  message: string;
}

function Contato() {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const { register, handleSubmit, reset } = useForm<InputsForm>();
  const form = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onSubmit: SubmitHandler<InputsForm> = (data) => {
    setLoading(true);
    if (form.current) {
      emailjs
        .sendForm("service_kxv0vqf", "template_xbaey3e", form.current, {
          publicKey: "miTdikF1hXbO-R0TX",
        })
        .then(
          (res) => {
            console.log("SUCCESS!");
            console.log(res);
            reset();
          },
          (error: any) => {
            console.log("FAILED...", error.text);
          }
        );
    }
    setLoading(false);
  };

  return (
    <Layout>
      <ContatoDetails>
        <a
          className="floatbutton"
          href="https://api.whatsapp.com/send/?phone=45998261934"
          target="_blank"
          rel="noreferrer"
        >
          <BsWhatsapp />
        </a>
        <Container maxWidth="lg">
          <Grid2 container spacing={2} sx={{ mt: 10 }}>
            <Grid2
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              size={{ xs: 12, md: 6 }}
            >
              <Grid2 size={{ xs: 12 }}>
                <Grid2
                  container
                  size={{ xs: 12 }}
                  spacing={2}
                  flexDirection="column"
                >
                  <Grid2 size={{ xs: 12 }}>
                    <Typography variant="h4">Conecte-se Conosco</Typography>
                  </Grid2>
                  <Grid2>
                    <Typography variant="body1">
                      Na Bellatchau, a nossa paixão é criar experiências
                      excepcionais para você. Queremos ouvir sua voz, suas
                      perguntas e suas ideias. Entre em contato conosco hoje
                      mesmo e deixe-nos ajudá-lo a realizar seus sonhos.
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2 size={{ xs: 12 }}>
                <img src={vector} alt="vector_image" className="img_contact" />
              </Grid2>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }} container>
              <Grid2 size={{ xs: 12 }}>
                <Card sx={{ p: 3 }}>
                  <Typography variant="h6" mb={4}>
                    Formulário de contato
                  </Typography>
                  <form onSubmit={handleSubmit(onSubmit)} ref={form}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: theme.spacing(5),
                      }}
                    >
                      <Input
                        label="Nome"
                        variant="outlined"
                        suffix={<PersonIcon />}
                        {...register("user_name")}
                        required
                      />
                      <Input
                        label="Email"
                        type="email"
                        variant="outlined"
                        suffix={<EmailIcon />}
                        {...register("user_email")}
                        required
                      />
                      <Input
                        label="Telefone"
                        variant="outlined"
                        suffix={<PhoneEnabledIcon />}
                        {...register("telefone")}
                        required
                      />
                      <Input
                        label="Messagem"
                        variant="outlined"
                        multiline
                        rows={4}
                      />
                      <Button
                        variant="contained"
                        type="submit"
                        sx={{ width: "150px" }}
                      >
                        {loading ? <CircularProgress /> : "Enviar"}
                      </Button>
                    </Box>
                  </form>
                </Card>
              </Grid2>
            </Grid2>
          </Grid2>
        </Container>
      </ContatoDetails>
    </Layout>
  );
}

export default Contato;
